exports.install = function (Vue, options) {
  Vue.prototype.setCookie = function (name, value, expireDate) {
    let d = new Date();
    d.setTime(d.getTime() + expireDate * 24 * 60 * 60 * 1000);
    let exp = "expires=" + d.toUTCString();
    document.cookie = name + "=" + value + ";" + exp + ";";
  };

  Vue.prototype.getCookie = function (name) {
    if (document.cookie) {
      let key = name + "=";
      let c_front = document.cookie.indexOf(key);
      if (c_front != -1) {
        c_front = c_front + key.length;
        let c_back = document.cookie.indexOf(";", c_front);
        if (c_back == -1) c_back = document.cookie.length;
        return document.cookie.substring(c_front, c_back);
      }
    }
    return "";
  };
  Vue.prototype.dateToString = function (dateS) {
    if (!dateS) {
      return "";
    }
    let date = new Date(dateS);
    let Y = date.getFullYear() + "-";
    let M =
      (date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) + "-";
    let D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    let H = " " + date.getHours() + ":";
    let Min =
      (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
      ":";
    let S =
      date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
    return Y + M + D + H + Min + S;
  };
  Vue.prototype.dateToYMD = function (dateS) {
    if (!dateS) {
      return;
    }
    let date = new Date(dateS);
    let Y = date.getFullYear() + "-";
    let M =
      (date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) + "-";
    let D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    return Y + M + D;
  };
  Vue.prototype.dateToYMD_compatible = function (dateS) {
    //  兼容Safari浏览器无法解析时间字符串格式如：2012-03-12 12：23：45，需要转为2012-03-12T12：23：45
    if (!dateS) {
      return;
    }
    // dateS = dateS.replace(' ', 'T')
    let date = new Date(dateS);
    let Y = date.getFullYear() + "-";
    let M =
      (date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) + "-";
    let D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    return Y + M + D;
  };

  Vue.prototype.dateToYMDHM = function (dateS) {
    if (!dateS) {
      return;
    }
    let date = new Date(dateS);
    let Y = date.getFullYear() + "-";
    let M =
      (date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) + "-";
    let D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    let H = " " + date.getHours() + ":";
    let Min =
      date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
    return Y + M + D + H + Min;
  };

  Vue.prototype.fmtTime = function (row, col) {
    let val = row[col.property];
    if (val) {
      let date = new Date(val);
      let Y = date.getFullYear() + "-";
      let M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      let D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      let H = " " + date.getHours() + ":";
      let Min =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":";
      let S =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return Y + M + D + H + Min + S;
    }
  };

  Vue.prototype.fmtTimeShort = function (row, col) {
    let val = row[col.property];
    if (!val) {
      return;
    }
    let date = new Date(val);
    let Y = date.getFullYear() + "-";
    let M =
      (date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) + "-";
    let D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    return Y + M + D;
  };

  (Vue.prototype.formatterValue = function (row) {
    let str = "";
    let titleArr = [];
    let item1 = parseInt(row.t_value & 1, 10);
    let item2 = parseInt(row.t_value & 2, 10);
    let item3 = parseInt(row.t_value & 4, 10);
    let item4 = parseInt(row.t_value & 8, 10);
    let item5 = parseInt(row.t_value & 16, 10);
    let item6 = parseInt(row.t_value & 32, 10);
    let item7 = parseInt(row.t_value & 64, 10);
    let item8 = parseInt(row.t_value & 128, 10);
    titleArr = [
      item1 ? "传感器关闭" : 0,
      item2 ? "电压不足" : 0,
      item3 ? "上通道异常" : 0,
      item4 ? "下通道异常" : 0,
      item5 ? "设备离线" : 0,
      item6 ? "设备倾倒" : 0,
      item7 ? "异常代码7" : 0,
      item8 ? "异常代码8" : 0,
    ];
    let arr = [];
    titleArr.forEach((value) => {
      if (value) {
        arr.push(value);
      }
    });
    str = arr.join(",");
    if (str == "") {
      str = "设备正常";
    }
    return str;
  }),
    (Vue.prototype.formatterErrorCode = function (code) {
      let arr = [0, 0, 0, 0, 0, 0, 0, 0];
      if (code == 0) {
        arr = [1, 1, 1, 1, 1, 1, 1, 1];
      } else {
        arr[8 - code] = 1;
      }
      return arr.join("");
    }),
    (Vue.prototype.twoArrSamElement = function (saveArr, arr) {
      let result = [];
      for (let i = 0; i < saveArr.length; i++) {
        for (let j = 0; j < arr.length; j++) {
          if (saveArr[i].name == arr[j].name) {
            result.push(saveArr[i]);
            break;
          }
        }
      }
      return result;
    }),
    (Vue.prototype.onlyInputNumber = function (event) {
      let value = event.target.value;
      value = value.replace(/[^0-9.-]/g, "");

      if (value.length > 1) {
        //去掉多余的负号 -
        let value1 = value.substring(0, 1);
        let value2 = value.substring(1);
        value2 = value2.replace(/[-]/g, "");
        value = value1 + value2;

        let num1 = value.indexOf(".");
        if (num1 > -1) {
          //去多余的小数点
          let num2 = value.indexOf(".", num1 + 1);
          if (num2 > -1) {
            value = value.substring(0, num2) + value.substring(num2 + 1);
          }
        }
      }
      event.target.value = value;
    });
  Vue.prototype.onlyInputDigital = function (event) {
    let value = event.target.value;
    value = value.replace(/[^0-9]/g, "");
    event.target.value = value;
  };

  Vue.prototype.someDaysAgo = function (days = 7) {
    // 当前时间的days天以前的现在
    let theDay = new Date().getTime() - days * 24 * 3600 * 1000;
    return new Date(theDay);
  };

  Vue.prototype.transformCoord = function (lat, lon, fromTo) {
    // longitude: "121.635414"
    // latitude: "29.884407"

    let GPS = {
      PI: 3.14159265358979324,
      x_pi: (3.14159265358979324 * 3000.0) / 180.0,
      delta: function (lat, lon) {
        var a = 6378245.0; //  a: 卫星椭球坐标投影到平面地图坐标系的投影因子。
        var ee = 0.00669342162296594323; //  ee: 椭球的偏心率。
        var dLat = this.transformLat(lon - 105.0, lat - 35.0);
        var dLon = this.transformLon(lon - 105.0, lat - 35.0);
        var radLat = (lat / 180.0) * this.PI;
        var magic = Math.sin(radLat);
        magic = 1 - ee * magic * magic;
        var sqrtMagic = Math.sqrt(magic);
        dLat =
          (dLat * 180.0) / (((a * (1 - ee)) / (magic * sqrtMagic)) * this.PI);
        dLon = (dLon * 180.0) / ((a / sqrtMagic) * Math.cos(radLat) * this.PI);
        return { lat: dLat, lon: dLon };
      },

      //WGS-84(大地坐标) to GCJ-02(火星坐标系)（高德，腾讯）
      gcj_encrypt: function (wgsLat, wgsLon) {
        if (this.outOfChina(wgsLat, wgsLon))
          return { lat: wgsLat, lon: wgsLon };

        var d = this.delta(wgsLat, wgsLon);
        return { lat: wgsLat + d.lat, lon: wgsLon + d.lon };
      },
      //GCJ-02 to WGS-84
      gcj_decrypt: function (gcjLat, gcjLon) {
        if (this.outOfChina(gcjLat, gcjLon))
          return { lat: gcjLat, lon: gcjLon };

        var d = this.delta(gcjLat, gcjLon);
        return { lat: gcjLat - d.lat, lon: gcjLon - d.lon };
      },
      //GCJ-02 to WGS-84 exactly
      gcj_decrypt_exact: function (gcjLat, gcjLon) {
        var initDelta = 0.01;
        var threshold = 0.000000001;
        var dLat = initDelta,
          dLon = initDelta;
        var mLat = gcjLat - dLat,
          mLon = gcjLon - dLon;
        var pLat = gcjLat + dLat,
          pLon = gcjLon + dLon;
        var wgsLat,
          wgsLon,
          i = 0;
        while (1) {
          wgsLat = (mLat + pLat) / 2;
          wgsLon = (mLon + pLon) / 2;
          var tmp = this.gcj_encrypt(wgsLat, wgsLon);
          dLat = tmp.lat - gcjLat;
          dLon = tmp.lon - gcjLon;
          if (Math.abs(dLat) < threshold && Math.abs(dLon) < threshold) break;

          if (dLat > 0) pLat = wgsLat;
          else mLat = wgsLat;
          if (dLon > 0) pLon = wgsLon;
          else mLon = wgsLon;

          if (++i > 10000) break;
        }
        //console.log(i);
        return { lat: wgsLat, lon: wgsLon };
      },
      //GCJ-02 to BD-09
      bd_encrypt: function (gcjLat, gcjLon) {
        var x = gcjLon,
          y = gcjLat;
        var z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * this.x_pi);
        var theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * this.x_pi);
        var bdLon = z * Math.cos(theta) + 0.0065;
        var bdLat = z * Math.sin(theta) + 0.006;
        return { lat: bdLat, lon: bdLon };
      },
      //BD-09 to GCJ-02
      bd_decrypt: function (bdLat, bdLon) {
        var x = bdLon - 0.0065,
          y = bdLat - 0.006;
        var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * this.x_pi);
        var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * this.x_pi);
        var gcjLon = z * Math.cos(theta);
        var gcjLat = z * Math.sin(theta);
        return { lat: gcjLat, lon: gcjLon };
      },
      //WGS-84 to Web mercator
      //mercatorLat -> y mercatorLon -> x
      mercator_encrypt: function (wgsLat, wgsLon) {
        var x = (wgsLon * 20037508.34) / 180;
        var y =
          Math.log(Math.tan(((90 + wgsLat) * this.PI) / 360)) / (this.PI / 180);
        y = (y * 20037508.34) / 180;
        return { lat: y, lon: x };
      },
      // Web mercator to WGS-84
      // mercatorLat -> y mercatorLon -> x
      mercator_decrypt: function (mercatorLat, mercatorLon) {
        var x = (mercatorLon / 20037508.34) * 180;
        var y = (mercatorLat / 20037508.34) * 180;
        y =
          (180 / this.PI) *
          (2 * Math.atan(Math.exp((y * this.PI) / 180)) - this.PI / 2);
        return { lat: y, lon: x };
      },
      // two point's distance
      distance: function (latA, lonA, latB, lonB) {
        var earthR = 6371000;
        var x =
          Math.cos((latA * this.PI) / 180) *
          Math.cos((latB * this.PI) / 180) *
          Math.cos(((lonA - lonB) * this.PI) / 180);
        var y =
          Math.sin((latA * this.PI) / 180) * Math.sin((latB * this.PI) / 180);
        var s = x + y;
        if (s > 1) s = 1;
        if (s < -1) s = -1;
        var alpha = Math.acos(s);
        var distance = alpha * earthR;
        return distance;
      },
      outOfChina: function (lat, lon) {
        if (lon < 72.004 || lon > 137.8347) return true;
        if (lat < 0.8293 || lat > 55.8271) return true;
        return false;
      },
      transformLat: function (x, y) {
        var ret =
          -100.0 +
          2.0 * x +
          3.0 * y +
          0.2 * y * y +
          0.1 * x * y +
          0.2 * Math.sqrt(Math.abs(x));
        ret +=
          ((20.0 * Math.sin(6.0 * x * this.PI) +
            20.0 * Math.sin(2.0 * x * this.PI)) *
            2.0) /
          3.0;
        ret +=
          ((20.0 * Math.sin(y * this.PI) +
            40.0 * Math.sin((y / 3.0) * this.PI)) *
            2.0) /
          3.0;
        ret +=
          ((160.0 * Math.sin((y / 12.0) * this.PI) +
            320 * Math.sin((y * this.PI) / 30.0)) *
            2.0) /
          3.0;
        return ret;
      },
      transformLon: function (x, y) {
        var ret =
          300.0 +
          x +
          2.0 * y +
          0.1 * x * x +
          0.1 * x * y +
          0.1 * Math.sqrt(Math.abs(x));
        ret +=
          ((20.0 * Math.sin(6.0 * x * this.PI) +
            20.0 * Math.sin(2.0 * x * this.PI)) *
            2.0) /
          3.0;
        ret +=
          ((20.0 * Math.sin(x * this.PI) +
            40.0 * Math.sin((x / 3.0) * this.PI)) *
            2.0) /
          3.0;
        ret +=
          ((150.0 * Math.sin((x / 12.0) * this.PI) +
            300.0 * Math.sin((x / 30.0) * this.PI)) *
            2.0) /
          3.0;
        return ret;
      },
    };
    if (fromTo == "GPSToGaode") {
      // GPS 转 高德
      let GPSToGaode = GPS.gcj_encrypt(lat, lon);
      return [GPSToGaode.lon, GPSToGaode.lat];
    }
    if (fromTo == "BaiduToGPS") {
      //  百度 转 GPS
      let BaiduToGaode = GPS.bd_decrypt(lat, lon);
      let GaodeToGPS = GPS.gcj_decrypt_exact(
        BaiduToGaode.lat,
        BaiduToGaode.lon
      );
      return GaodeToGPS;
    }
    if (fromTo == "GPSToBaidu") {
      // GPS 转 百度
      let GPSToGaode = GPS.gcj_encrypt(lat, lon);
      let GaodeToBaidu = GPS.bd_encrypt(GPSToGaode.lat, GPSToGaode.lon);
      return GaodeToBaidu;
    }
  };
};



// WEBPACK FOOTER //
// ./src/global.js